import { Link } from 'react-router-dom';
import { Flame, Menu as MenuIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TenantSwitcher } from '@/components/primitives/TenantSwitcher';
import { UserMenu } from '@/components/primitives/UserMenu';
import { RoleGuard } from '@/components/primitives/RoleGuard';
import { useAuth } from '@/contexts/AuthContext';

interface TopBarProps {
  onMenuClick?: () => void;
  showMenu?: boolean;
}

export function TopBar({ onMenuClick, showMenu }: TopBarProps) {
  const { isAuthenticated } = useAuth();

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-2 border-b border-border bg-background/95 px-3 backdrop-blur supports-[backdrop-filter]:bg-background/80 sm:px-6">
      {showMenu && (
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <MenuIcon className="h-5 w-5" />
        </Button>
      )}
      <Link to={isAuthenticated ? '/dashboard' : '/'} className="flex items-center gap-2">
        <Flame className="h-5 w-5 text-primary" />
        <span className="font-semibold tracking-tight">Wildfire Reporting</span>
      </Link>
      <div className="ml-auto flex items-center gap-2">
        <RoleGuard authenticated>
          <TenantSwitcher />
        </RoleGuard>
        <RoleGuard authenticated>
          <UserMenu />
        </RoleGuard>
        <RoleGuard anonymous>
          <Button asChild variant="default" size="sm">
            <Link to="/auth/login">Sign in</Link>
          </Button>
        </RoleGuard>
      </div>
    </header>
  );
}

export default TopBar;
